
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meme-generator",
      function () {
        return require("private-next-pages/meme-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meme-generator"])
      });
    }
  